"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var authSelectors_1 = require("../selectors/authSelectors");
var settingsSelectors_1 = require("../selectors/settingsSelectors");
var i18n_1 = __importDefault(require("../i18n"));
var reportErrorsToInstrumentation_1 = __importStar(require("../helper/reportErrorsToInstrumentation"));
var dqeService_1 = require("../services/dqeService");
var dqeState_1 = require("../states/dqeState");
function stringNotEmpty(v) {
    if (v === null || v === void 0 ? void 0 : v.length)
        return " ".concat(v, " ");
    return '';
}
function onlyUniqueByFullLabel(element, index, self) {
    return self.map(function (el) { return el === null || el === void 0 ? void 0 : el.fullLabel; }).indexOf(element === null || element === void 0 ? void 0 : element.fullLabel) === index;
}
function handleSuggestions(data) {
    var suggestions = data;
    suggestions.forEach(function (suggestion) {
        var _a, _b, _c;
        // si la suggestion n'indique pas un numéro de rue mais une liste de numéro possible
        if (!((_a = suggestion === null || suggestion === void 0 ? void 0 : suggestion.numSeul) === null || _a === void 0 ? void 0 : _a.length) && ((_b = suggestion === null || suggestion === void 0 ? void 0 : suggestion.listeNumero) === null || _b === void 0 ? void 0 : _b.length)) {
            // on crée autant de suggestion que des numéro et on les ajoute à la liste
            var numbers = (_c = suggestion === null || suggestion === void 0 ? void 0 : suggestion.listeNumero) === null || _c === void 0 ? void 0 : _c.split(';');
            numbers.forEach(function (n) {
                var suggToAdd = __assign({}, suggestion);
                suggToAdd.numSeul = n;
                suggestions.push(suggToAdd);
            });
        }
    });
    suggestions = suggestions.filter(function (s) { var _a, _b; return ((_a = s === null || s === void 0 ? void 0 : s.numSeul) === null || _a === void 0 ? void 0 : _a.length) || !((_b = s === null || s === void 0 ? void 0 : s.listeNumero) === null || _b === void 0 ? void 0 : _b.length); });
    //on format la liste pour le composant et on enléve les doublons
    return suggestions.map(function (address, index) {
        return {
            id: index.toString(),
            fullLabel: "".concat(address === null || address === void 0 ? void 0 : address.numSeul, " ").concat(address === null || address === void 0 ? void 0 : address.voie).concat(stringNotEmpty(address === null || address === void 0 ? void 0 : address.complement)).concat(stringNotEmpty(address === null || address === void 0 ? void 0 : address.lieuDit), " ").concat(address === null || address === void 0 ? void 0 : address.codePostal, " ").concat(address === null || address === void 0 ? void 0 : address.localite),
            value: address,
            label: "".concat(address === null || address === void 0 ? void 0 : address.numSeul, " ").concat(address === null || address === void 0 ? void 0 : address.voie).concat(stringNotEmpty(address === null || address === void 0 ? void 0 : address.complement)).concat(stringNotEmpty(address === null || address === void 0 ? void 0 : address.lieuDit)),
            label2: "".concat(address === null || address === void 0 ? void 0 : address.codePostal, ", ").concat(address === null || address === void 0 ? void 0 : address.localite)
        };
    })
        .filter(onlyUniqueByFullLabel);
}
function getAddressSuggestionsEffect(action) {
    var token, response, e_1, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error("Missing Access Token");
                return [4 /*yield*/, (0, effects_1.call)(dqeService_1.fetchAddressSuggestions, action.payload, token)];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(dqeState_1.dqeActions.getAddressSuggestionsSuccess(handleSuggestions(response.data)))];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(dqeState_1.dqeActions.getAddressSuggestionsFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getAddressSuggestionsEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getOfflineAddressSuggestionsEffect(action) {
    var response, e_2, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 7]);
                return [4 /*yield*/, (0, effects_1.call)(dqeService_1.fetchOfflineAddressSuggestions, action.payload)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(dqeState_1.dqeActions.getAddressSuggestionsSuccess(handleSuggestions(response.data)))];
            case 2:
                _a.sent();
                return [3 /*break*/, 7];
            case 3:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 4:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(dqeState_1.dqeActions.getAddressSuggestionsFailure(errorMsg))];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getOfflineAddressSuggestionsEffect.name))];
            case 6:
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function dqeEffects() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(dqeState_1.dqeActions.getAddressSuggestions.type, getAddressSuggestionsEffect)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(dqeState_1.dqeActions.getOfflineAddressSuggestions.type, getOfflineAddressSuggestionsEffect)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = dqeEffects;
